import React, { useState } from "react";
import "./SelectField.css";
import { ReactComponent as CheckMark } from "../../assets/icons/check-mark.svg";

export default function SelectField(props) {
  function updateSelection(option) {
    props.setSelected(option);
  }

  return (
    <div className="select-field-container">
      {props.options.map((option) => {
        let selected;

        if (props.isMulti) {
          selected = props.selected.includes(option);
        } else {
          selected = option === props.selected;
        }

        return (
          <button
            className={`select-field-option ${
              selected
                ? "select-field-option-selected"
                : "select-field-option-unselected"
            }`}
            key={option}
            onClick={() => {
              updateSelection(option);
            }}
            {...props}
          >
            {selected ? (
              <CheckMark
                style={{ position: "absolute", transform: "translateX(-100%)" }}
                className="feature-icon"
                fill="white"
              />
            ) : null}
            {option}
          </button>
        );
      })}
    </div>
  );
}
